import styled from "styled-components";

/**
 * CLE-2792 review round 5 — ONE TYPE SCALE for every benefit-configuration surface.
 *
 * 🚨 THE SCALE IS THE APP'S, NOT A NEW ONE. Every value here is already in
 * `clear-theme-overrides.css`: a DataTable header is `0.875rem` at weight 600 in `--color-label`,
 * `p-button-sm` is `0.875rem`, and body text is `--text-color`. What was inconsistent was this
 * card, which mixed the theme's 1rem table cells with its own `text-sm` prose, so the exceptions
 * table and the payer filters read a size larger than everything around them.
 *
 * The four steps, and nothing between them:
 *
 * | role                                        | size       | colour                     |
 * |---------------------------------------------|------------|----------------------------|
 * | layer heading (accordion)                    | `1.15rem`  | `--text-color`             |
 * | section title                                | `1rem`     | `--text-color`             |
 * | body, table cell, row title, dialog label    | `0.875rem` | `--text-color`             |
 * | caption, subtitle, helper                    | `0.75rem`  | `--text-color-secondary`   |
 *
 * ⚠️ WRAP DIALOG AND DRAWER CONTENT IN THIS TOO. They render through a portal, outside the card's
 * DOM, so a wrapper at the card root does not reach them — which is exactly how a dialog ends up
 * one size larger than the screen that opened it.
 */
export const Surface = styled.div`
  font-size: 0.875rem;
  color: var(--text-color);

  /*
    The theme's own table type, with the ONE cell size this card uses. The header rule restates the
    theme's values rather than lightening them: a header lighter than its rows reads as a caption.
  */
  .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--color-label);
    padding: 0.75rem 1rem;
  }

  .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.875rem;
    color: var(--text-color);
    padding: 0.75rem 1rem;
  }

  /* Labels above inputs are body text, not captions — they name the thing being edited. */
  label {
    font-size: 0.875rem;
  }

  small {
    font-size: 0.75rem;
    color: var(--text-color-secondary);
  }
`;

/** A section's own title: the step above body, below a layer heading. */
export const SectionTitle = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-color);
`;
